import { DeleteOutline as TrashIcon } from '@mui/icons-material';

const Trash = (): JSX.Element => <TrashIcon fontSize="inherit" />;

export default Trash;
